import { Navigate } from 'react-router';
import { useHasRole } from '../auth/useHasRole';

/** Old bookmark `/hr/time-off/sync-logs` → admin path for ItSysAdmin, else access denied. */
export function TimeOffSyncLogsLegacyRedirect() {
  const { isItSysAdmin } = useHasRole();

  if (isItSysAdmin()) {
    return <Navigate to="/admin/time-off/sync-logs" replace />;
  }

  return <Navigate to="/access-denied" replace />;
}
